// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"styles_dropdown__mBJiw","dropdown-item":"styles_dropdown-item__kUhwx"};